import _ from 'lodash'
import { JSONObject } from 'common/src/vtj/types/json.type'

export type SettingsData = JSONObject

export type KeyPath = string | Array<string>

export interface SettingsApi {
  get(keyPath: KeyPath): any // eslint-disable-line @typescript-eslint/no-explicit-any
  isFeatureEnabled(feature: string): boolean
  getAll(): any // eslint-disable-line @typescript-eslint/no-explicit-any
}

// TODO: remove export; currently needed for public-settings.js in different packages
export function exposeSettingsApi(settings: SettingsData): SettingsApi {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function get(keyPath: KeyPath): any {
    if (_.has(settings, keyPath)) {
      return _.get(settings, keyPath)
    } else {
      throw new Error(`Setting not found by key path '${keyPath}'`)
    }
  }

  return {
    get,
    isFeatureEnabled: (feature) =>
      _.includes(get('enabledFeatures') as string[], feature),
    getAll: () => settings as any, // eslint-disable-line @typescript-eslint/no-explicit-any
  }
}
